import {  RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
    {
        name: 'resetProductionHousePassword',
        path: '/reset-production-house-password',
        component: () => import('./production-house-reset-password-page.vue'),
        meta: {
            layout: 'blank-layout'
        }
    },
    {
        name: 'resetFreelancerPassword',
        path: '/reset-freelancer-password',
        component: () => import('./freelancer-reset-password-page.vue'),
        meta: {
            layout: 'blank-layout'
        }
    },
    {
        name: 'resetPassword',
        path: '/reset-password',
        component: () => import('./reset-password-page.vue'),
        meta: {
            layout: 'blank-layout'
        }
    },
]

export default routes;